
let savedText = null;
let savedWidth = 0;

export default function getTextWidth(text, font) {

    if (text !== savedText) {
        const canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement("canvas"));
        const context = canvas.getContext("2d");
        context.font = font;
        const metrics = context.measureText(text);
        savedText = text;
        savedWidth = metrics.width;
    }

    return savedWidth;
}
